import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ApiService from '../util/ApiService';

const StatesSelect = ({ value, onChange }) => {
    const [ufs, setUfs] = useState([]);

    useEffect(() => {
        const storedUfs = localStorage.getItem("ufs");

        if (storedUfs) {
            setUfs(JSON.parse(storedUfs));
        } else {
            ApiService.send("get", process.env.REACT_APP_URL_API + "address/states", [], false)
                .then((res) => {
                    const data = res.data;
                    const ufsData = data.map((uf) => ({
                        value: uf.code,
                        label: uf.name
                    }));
                    setUfs(ufsData);
                    localStorage.setItem("ufs", JSON.stringify(ufsData));
                })
                .catch((error) => {
                    console.error("Erro ao carregar estados:", error);
                });
        }
    }, []);

    return (
        <Select
            value={value}
            onChange={onChange}
            options={ufs}
            placeholder="Estado"
            isSearchable
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({
                    ...base,
                    zIndex: 9999
                }),
                menu: base => ({
                    ...base,
                    zIndex: 9999
                })
            }}
        />
    );
};

export default StatesSelect;
